const getTeamLayoutSlug = (url: string): string => {
    const matches = url.match(new RegExp('/v[0-9].+?TEAM'))
    return matches && matches.length ? `${matches[0]}/{id}` : url
}

export default getTeamLayoutSlug
